import { P as head, Q as slot } from "../../chunks/index2.js";
import { a as analytics } from "../../chunks/analytics.js";
function _layout($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    analytics.page();
    head("12qhfyh", $$renderer2, ($$renderer3) => {
      $$renderer3.push(`<link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,1,200" rel="stylesheet"/>`);
    });
    $$renderer2.push(`<div class="fade-in bg-white w-full h-full overflow-x-hidden" id="app"><!--[-->`);
    slot($$renderer2, $$props, "default", {});
    $$renderer2.push(`<!--]--></div>`);
  });
}
export {
  _layout as default
};
